import { useCallback } from 'react';
import { AdminAppState, SystemConfig } from '../shared/types/system';

export function useRegistryPatch(
	setState: React.Dispatch<React.SetStateAction<AdminAppState | null>>
): {
	patchState: (type: keyof AdminAppState, updatedRecord: any, idField: string) => void;
	patchConfig: (updates: Partial<SystemConfig>) => void;
} {
	const patchState = useCallback((
		type: keyof AdminAppState,
		updatedRecord: any,
		idField: string
	) => {
		setState(current => {
			if (!current) return current;
			const collection = current[type];
			if (!Array.isArray(collection)) return current;

			const index = collection.findIndex((item: any) => item[idField] === updatedRecord[idField]);

			const newCollection = [...collection];
			if (index !== -1) {
				newCollection[index] = { ...newCollection[index], ...updatedRecord };
			} else {
				newCollection.unshift(updatedRecord);
			}

			return {
				...current,
				[type]: newCollection,
				serverTimestamp: new Date().toISOString()
			};
		});
	}, [setState]);

	const patchConfig = useCallback((updates: Partial<SystemConfig>) => {
		setState(current => {
			if (!current) return current;
			return {
				...current,
				config: { ...current.config, ...updates },
				serverTimestamp: new Date().toISOString()
			};
		});
	}, [setState]);

	return { patchState, patchConfig };
}
